import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './footer/footer.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { AboutComponent } from './about/about.component';
import { AppRoutingModule } from './/app-routing.module';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HowworkComponent } from './howwork/howwork.component';
import { SupportComponent } from './support/support.component';
import { ComingComponent } from './coming/coming.component';
import { EmailComponent } from './email/email.component';
import { MemberComponent } from './member/member.component';
import { SocialLoginModule, AuthServiceConfig } from 'angularx-social-login';
import { GoogleLoginProvider, FacebookLoginProvider} from 'angularx-social-login';
import { FindSavingComponent } from './find-saving/find-saving.component';
import { AdminComponent } from './admin/admin.component';
import { TransacitionComponent } from './transacition/transacition.component';
import { BudgetComponent } from './budget/budget.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { environment } from '../environments/environment';
import { TranscationDetailsComponent } from './transcation/transcation-details/transcation-details.component';
import { TranscationListComponent } from './transcation/transcation-list/transcation-list.component';
import { CreateTranscationComponent } from './transcation/create-transcation/create-transcation.component';
import { SalaryDetailsComponent } from './salary/salary-details/salary-details.component';
import { SalaryListComponent } from './salary/salary-list/salary-list.component';
import { CreateSalaryComponent } from './salary/create-salary/create-salary.component';
import { DemoComponent } from './demo/demo.component';

const config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider('298564818619-n9rknb2o5ohmpr3snde2fabapmk6olqv.apps.googleusercontent.com')
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider('2089980544649547')
  },
]);

export function provideConfig() {
  return config;
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FooterComponent,
    LoginComponent,
    SignupComponent,
    AboutComponent,
    PageNotFoundComponent,
    HowworkComponent,
    SupportComponent,
    ComingComponent,
    EmailComponent,
    MemberComponent,
    FindSavingComponent,
    AdminComponent,
    TransacitionComponent,
    BudgetComponent,
    TranscationDetailsComponent,
    TranscationListComponent,
    CreateTranscationComponent,
    SalaryDetailsComponent,
    SalaryListComponent,
    CreateSalaryComponent,
    DemoComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SocialLoginModule,
    FormsModule,
    HttpClientModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule, // for database
  ],
  providers: [ {
    provide: AuthServiceConfig,
    useFactory: provideConfig},
    ],
  bootstrap: [AppComponent]
})
export class AppModule { }
